<template>
	<div>
		<advertisement-top-banner-text />
		<template v-if="$options.components['advertisement-grocery-banner']">
			<advertisement-grocery-banner />
		</template>

		<div class="container">
			<h1 class="heading-category mt-3">Shop By Category</h1>
			<sections-slider
				v-if="category && category.length"
				:list="category"
				:theme="theme"
				subTitle="Our Category"
				:hasInnerBackground="true"
				:hasButton="false"
				:withSlider="true"
			>
				<template slot="default" slot-scope="{ listItem }">
					<div class="item-box">
						<items-item
							:itemLogo="true"
							:product="listItem"
							:incrementDecrementKey="false"
							:marketRoute="{
								name: `grocery-listing`,
								params: {
									data: listItem.name,
								},
							}"
						></items-item>
					</div>
				</template>
			</sections-slider>
		</div>

		<!-- <template v-if="$options.components['advertisement-loading']">
        <advertisement-loading v-if="isLoading" />
      </template> -->
		<!-- <sections-slider
          :list="trending"
          subTitle="Trending"
          :showTitle="true"
          :hasBackground="false"
          :hasButton="true"
          class="suggested-slider"
          :withSlider="true"
          :viewMorePage="{
            name: `trending-list`,
          }"
        >
          <template slot="default" slot-scope="{ listItem }">
            <div class="item-box">
              <items-item
                :itemNoBg="true"
                :product="listItem"
                :incrementDecrementKey="true"
                class="suggester-div"
              >
              </items-item>
            </div>
          </template>
        </sections-slider> -->
		<div
			class="bg-colors sub-head"
			v-for="marketItem in Object.keys(marketDataList)"
			:key="marketItem"
		>
			<sections-slider
				v-if="marketDataList[marketItem].length > 0"
				:list="marketDataList[marketItem]"
				:theme="theme"
				:subTitle="marketItem"
				:hasButton="true"
				:onlyTitle="false"
				:showTitle="true"
				:itemSubTitle="true"
				:hasBackground="false"
				class="suggested-slider"
				:withSlider="true"
				:viewMorePage="{
					name: `grocery-listing`,
					params: {
						data: marketItem,
						market: $route.params.market,
					},
				}"
			>
				<template slot="default" slot-scope="{ listItem }">
					<div class="item-box">
						<items-item
							:itemNoBg="true"
							:product="listItem"
							:incrementDecrementKey="true"
							class="suggester-div"
						>
						</items-item>
					</div>
				</template>
			</sections-slider>
		</div>
		<!-- <b-container>
        <template v-if="$options.components['advertisement-fashion-middle']">
          <advertisement-fashion-middle />
        </template>
      </b-container> -->
		<div>
			<img src="\img\bottomBanner.png" class="bottom-banner" />
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";

export default {
	name: "groceryMarket",
	data() {
		return {
			isLoading: false,
			theme: {},
			marketName: "",
		};
	},
	computed: {
		...mapState({
			currentPosition: (state) => state.location.currentPosition,
			marketDataList: (state) => state.groceryMarket.marketDataList,
			marketList: (state) => state.groceryMarket.marketList,
			category: (state) => state.groceryMarket.category,
			trending: (state) => state.groceryMarket.trending,
			marketListData: (state) => state.groceryMarket.marketListData,
		}),
	},

	async mounted() {
		// this.isLoading = true;
		// await this.$store.dispatch("groceryMarket/fetchAllMarket");
		// const marketId = this.marketList.filter((e) => {
		//   if (e.name == this.$route.params.market) {
		//     this.theme = e.theme;
		//     this.$store.commit("theme/updateTheme", this.theme);
		//     if (e.name == this.$route.params.market) {
		//       this.marketName = this.$route.params.market;
		//     }
		//     this.$store.commit("theme/updateName", this.marketName);
		//     return e._id;
		//   }
		// });
		// await this.$store.dispatch(
		//   "groceryMarket/fetchfashionMarketCategory",
		//   marketId[0]._id
		// );
		// await this.$store.dispatch(
		//   "groceryMarket/fetchfashionArrivals",
		//   this.currentPosition
		// );
		// this.isLoading = false;
	},

	created() {
		document.body.scrollTop = 0;
		document.documentElement.scrollTop = 0;
	},
};
</script>

<style scoped>
.heading-category {
	font-family: Poppins;
	font-size: 21px;
	font-weight: 600;
	color: #212529;
}
.bg-colors {
	background: #f8f8f8;
}
.view-more-btn {
	background: var(--custom-color) !important;
	border: 1px solid var(--custom-color) !important;
}
.stores-slider .item-box {
	margin: 0 12px;
	width: 208px;
	/* background: #ffffff; */
	box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.12);
	border-radius: 6px;
}

.suggested-slider .item-box {
	margin: 0 12px;
	width: 266px;
	display: block;
}

.marketitem-slider .item-box {
	margin: 0 12px;
	width: 208px;
	display: block;
}
.bg-colors {
	background: #f8f8f8;
}
@media (max-width: 768px) {
	.v-slide-group__next,
	.v-slide-group__prev {
		display: none !important;
	}

	.marketitem-slider .item-box {
		width: 266px;
	}

	.stores-slider .item-box {
		margin: 0 12px;
		width: 136px;
	}
}
.slider-contaner-2 {
	width: 80%;
}
.slider-contaner-1 {
	width: 100%;
}
.bottom-banner {
	display: block;
	margin: 50px auto 0;
	width: 100%;
	max-width: 1240px;
	height: auto;
}
@media (max-width: 768px) {
	.bottom-banner {
		margin-top: 20px;
		width: 90%;
		height: auto;
	}
}
</style>
